import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckOutlined } from '@mui/icons-material';
import { Button } from '@mui/material';
import CustomDialog from '@ui/components/common/Dialog';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import AddNewTask from '.';
const AddNewTaskDialog = ({ open, onClose, edit = false, taskData, isCreateAllowed, onTaskCreated }) => {
    const { t } = useTranslation();
    const formRef = useRef(null);
    const handleSubmit = () => {
        if (formRef.current) {
            formRef.current.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
        // Note: onClose() is now handled by the AddNewTask component after successful form submission
    };
    return (_jsx(CustomDialog, { open: open, onClose: onClose, titleIcon: '/assets/images/editTask.png', titleWithIcon: edit ? t('tasks.editTask') : t('tasks.newTask'), actions: _jsxs(_Fragment, { children: [_jsx(Button, { fullWidth: true, onClick: onClose, variant: 'outlined', color: 'inherit', size: 'large', children: t('actions.cancel') }), _jsx(Button, { fullWidth: true, variant: 'contained', color: 'inherit', size: 'large', startIcon: edit ? null : _jsx(CheckOutlined, {}), onClick: handleSubmit, children: edit ? t('actions.saveChanges') : t('actions.createTask') })] }), children: _jsx(AddNewTask, { isCreateAllowed: isCreateAllowed, edit: edit, dialog: true, taskData: taskData, formRef: formRef, onClose: onClose, padding: true, onTaskCreated: onTaskCreated }, `${taskData?.id}-${taskData?.eventId}`) }));
};
export default AddNewTaskDialog;
